/**
 * Quick Add Bar – adds variant to cart directly from collection page
 */
class QuickAddBar extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const productBlock = this.closest('.product-block');
    const imageCont = productBlock?.querySelector('.image-cont');

    // Use event delegation for size buttons
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.quick-add-bar__option');
      if (!btn || btn.classList.contains('quick-add-bar__option--unavailable')) return;
      e.preventDefault();
      e.stopPropagation();
      this.addToCart(btn);
    });

    // Close button inside the bar
    const closeBtn = this.querySelector('.quick-add-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.classList.remove('is-active');
        if (trigger) trigger.classList.remove('is-hidden');
      });
    }

    // Plus trigger button (sibling before this element)
    const trigger = imageCont?.querySelector('.quick-add-bar__trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Close all other open bars
        document.querySelectorAll('.quick-add-bar.is-active').forEach((bar) => {
          if (bar !== this) {
            bar.classList.remove('is-active');
            bar.closest('.image-cont')?.querySelector('.quick-add-bar__trigger')?.classList.remove('is-hidden');
          }
        });
        const opening = this.classList.toggle('is-active');
        trigger.classList.toggle('is-hidden', opening);
      });
    }

    // Close when tapping outside (mobile)
    document.addEventListener('click', (e) => {
      if (
        this.classList.contains('is-active') &&
        !this.contains(e.target) &&
        !trigger?.contains(e.target)
      ) {
        this.classList.remove('is-active');
        if (trigger) trigger.classList.remove('is-hidden');
      }
    });
  }

  async addToCart(btn) {
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const sectionsToUpdate = ['page-header', 'cart-drawer']
      .map((sel) => document.querySelector(sel))
      .filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Quick add error:', data.description || data.message);
        btn.classList.remove('is-loading');
        return;
      }

      // Update cart drawer / header sections
      if (data.sections && sectionsToUpdate.length) {
        sectionsToUpdate.forEach((el) => {
          if (data.sections[el.dataset.sectionId]) {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          }
        });
      }

      // Dispatch cart events so the theme reacts
      this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      this.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { variantId: data.variant_id }
      }));

      // Visual feedback on the button
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1500);

      // Always open the side cart drawer so user sees the item was added
      const drawer = document.querySelector('.js-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        // Fallback: dispatch event that the cart-drawer listens for
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      }
    } catch (err) {
      console.error('Quick add error:', err);
      btn.classList.remove('is-loading');
    }
  }
}

customElements.define('quick-add-bar', QuickAddBar);
